import { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

const Popup = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  
  /* Message wrapping and centering rules */
  width: max-content;
  max-width: 240px;
  box-sizing: border-box;
`;

const Message = styled.p`
  font-size: 13px;
  margin: 0 0 12px;
  line-height: 1.5;
  text-align: center;
  word-break: break-word;
  white-space: normal;
  color: #1f2937;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

const Button = styled.button`
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  /* Primary vs Secondary button styles using props */
  background: ${(props) => (props.$primary ? "#e24b4a" : "transparent")};
  color: ${(props) => (props.$primary ? "#fff" : "#4b5563")};
  border: ${(props) => (props.$primary ? "none" : "1px solid #d1d5db")};

  &:hover {
    opacity: 0.9;
    background: ${(props) => (props.$primary ? "#d33f3e" : "#f9fafb")};
  }
`;

const Trigger = styled.div`
  cursor: pointer;
`;

const PopConfirm = ({
  message = "Are you sure?",
  onConfirm,
  onCancel,
  okText = "Delete",
  cancelText = "Cancel",
  children,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleConfirm = () => {
    setOpen(false);
    onConfirm?.();
  };

  const handleCancel = () => {
    setOpen(false);
    onCancel?.();
  };

  return (
    <Container ref={ref}>
      {open && (
        <Popup>
          <Message>{message}</Message>
          <ButtonGroup>
            <Button onClick={handleCancel}>
              {cancelText}
            </Button>
            <Button $primary onClick={handleConfirm}>
              {okText}
            </Button>
          </ButtonGroup>
        </Popup>
      )}
      <Trigger onClick={() => setOpen((v) => !v)}>{children}</Trigger>
    </Container>
  );
};

export default PopConfirm;